import React from "react";

import { Search } from "@trejgun/material-ui-icons-google";
import Amplify, { Auth } from "aws-amplify";
import { browserHistory } from "react-router";
import { Link } from "react-router";
import {
  checkIfBlogTeam,
  currentYear,
  getUserEmail,
  getUserGroup,
  isLoggedIn,
} from "../../../utils/utils";

import "./Signin.css";
import { setUserEmail } from "../../../redux/UAM/UAMActions";
import { connect } from "react-redux";
import SkeletonLoader from "../../Skeleton/SkeletonLoader";
import { resendConfirmationCode } from "../../../utils/utils";
import { Button, Modal } from "react-bootstrap";
import SigninBlue from "../../../assets/app/img/logo-signin-blue.png";
import {
  trackSigninPageViewEvent,
  trackSignInWithGoogleButtonClickEvent,
} from "../../../utils/facebookPixelEvents";

import { auth, signUpGoogle } from "../../../firebase";
import firebase from "firebase/app";
import { Helmet } from "react-helmet";
import { getUserMetaData } from "../../../firestoreQueries";

const initialFormData = Object.freeze({
  email: "",
  password: "",
});

// const handleSignin = () => {};
/**
 * Handles Google sign-in using Firebase.
 *
 * @param {Event} e - The event object.
 */
const handleGoogleSignIn = async (e) => {
  try {
    // Track the sign-in with Google button click event in production.
    if (process.env.REACT_APP_ENV === "production") {
      trackSignInWithGoogleButtonClickEvent();
    }

    e.preventDefault();
    console.log("Calling Google sign-in Firebase...");

    // Create a GoogleAuthProvider instance and set custom parameters.
    const provider = new firebase.auth.GoogleAuthProvider();
    provider.setCustomParameters({
      prompt: "select_account",
    });

    // Sign in with the Google popup and get the OAuth credential.
    const result = await firebase.auth().signInWithPopup(provider);
    const credential = result.credential;

    // Get the Google Access Token and the signed-in user info.
    const token = credential.accessToken;
    const user = result.user;

    console.log("Google sign-in successful:");
    console.log("Google credentials:", credential);
    console.log("Google token:", token);
    console.log("Google user:", user);

    // Redirect to the home page.
    try {
      browserHistory.push("/app");
    } catch (error) {
      console.error("Browser history push error:", error);
    }
  } catch (error) {
    // Handle errors and show an alert message.
    const errorCode = error.code;
    const errorMessage = error.message;
    const email = error.email;
    const credential = error.credential;
    console.log("Google sign-in failed");
    console.log("Error message:", errorMessage);
    alert(errorMessage);
  }
};

const handleSignIn = () => { };

function Signin(props) {
  const [loginStatus, setLoginStatus] = React.useState(false);
  const [showLoader, setShowLoader] = React.useState(true);
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const [isOpenModalReset, setIsOpenModalReset] = React.useState(false);
  const [authCode, setAuthCode] = React.useState();
  const [authCodeReset, setAuthCodeReset] = React.useState();
  const [newPassword, setNewPasswordReset] = React.useState();

  const openModal = () => {
    setIsOpenModal(true);
  };
  const closeModal = () => {
    setIsOpenModal(false);
  };
  const openModalReset = () => {
    setIsOpenModalReset(true);
  };
  const closeModalReset = () => {
    setIsOpenModalReset(false);
  };

  const handleChangeAuthCode = (e) => {
    setAuthCode(e.target.value.trim());
  };
  const handleChangeAuthCodeReset = (e) => {
    setAuthCodeReset(e.target.value.trim());
  };
  const handleChangeNewPasswordReset = (e) => {
    setNewPasswordReset(e.target.value.trim());
  };

  async function confirmSignUp(username, code) {
    try {
      await Auth.confirmSignUp(username, code);
    } catch (error) {
      console.log("error confirming sign up", error);
      alert(error.message);
    }
  }

  const handleSubmitConfirmSignUp = (e) => {
    e.preventDefault();
    console.log(authCode);
    // ... submit to API or something
    if (authCode == 0) {
      alert("Auth Code cannot be empty!");
    } else {
      console.log("Yay");
      confirmSignUp(formData.email, authCode)
        .then((resp) => {
          console.log(resp);
          browserHistory.push("/app");
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  const handleResetSubmitConfirmSignUp = (e) => {
    e.preventDefault();
    console.log(authCode);
    // ... submit to API or something
    if (authCodeReset == 0) {
      alert("Auth Code cannot be empty!");
    } else {
      console.log("Yay");
      Auth.forgotPasswordSubmit(formData.email, authCodeReset, newPassword)
        .then((resp) => {
          console.log(resp);
          browserHistory.push("/app");
        })
        .catch((err) => console.log(err));
    }
  };

  const handleResendVerificationCode = (e) => {
    e.preventDefault();
    const resp = resendConfirmationCode(formData.email);
    if (resp === true) {
      alert("Verification code sent again successfully");
    } else {
      alert("Something went wrong... Please try again later");
    }
  };
  const handleResendConfirmationCode = (e) => {
    e.preventDefault();
    const resp = resendConfirmationCode(formData.email);
    if (resp === true) {
      alert("Verification code sent again successfully");
    } else {
      alert("Something went wrong... Please try again later");
    }
  };

  React.useEffect(() => {
    const setTitleAndTrackPageView = async () => {
      document.title = "Sign In";
      if (process.env.REACT_APP_ENV === "production") {
        trackSigninPageViewEvent();
      }
    };

    const checkLoginStatus = async () => {
      try {
        const resp = await isLoggedIn("signin");
        console.log("isLoggedIn Signin:: " + resp);
        const email = await getUserEmail()
        const userMetadata = await getUserMetaData(email);
        console.log("user metadata signin", userMetadata);
        // // check if there is a userMetadata
        // if (userMetadata.exists) {
        //   console.log("User Metadata:: ", userMetadata.data());
        // } else {
        //   const metaDataToAdd = {
        //     userID: auth.currentUser.uid,
        //     email: auth.currentUser.email,
        //     preferences: {
        //       web: null,
        //       android: null,
        //     }
        //   }
        //   console.log("User Metadata to add:: ", metaDataToAdd);
        //   const metadataResp = insertUserMetaData(metaDataToAdd);
        //   console.log("User Metadata added:: ", metadataResp);
        // }

        setLoginStatus(resp === true);
        setShowLoader(false);
      } catch (error) {
        console.log("Sign Component::: Not Logged in");
        setLoginStatus(false);
        setShowLoader(false);
      }
    };

    setTitleAndTrackPageView();
    checkLoginStatus();
  }, []);

  const handleChange = (e) => {
    updateFormData({
      ...formData,

      // Trimming any whitespace
      [e.target.name]: e.target.value.trim(),
    });
  };
  const [formData, updateFormData] = React.useState(initialFormData);

  async function signUpNormal(e) {
    e.preventDefault();

    const email = formData.email;
    const password = formData.password;
    console.log("Email", email);
    try {
      auth
        .signInWithEmailAndPassword(email, password)
        .then((userCredential) => {
          // Signed in
          var user = userCredential.user;
          console.log(user);
          browserHistory.push("/app");
          // ...
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.log(errorCode, errorMessage);
          browserHistory.push("/app");
        });
    } catch (error) {
      console.log(error);
      if (error.message == "User is not confirmed.") {
        alert(error.message);
        const resp = await resendConfirmationCode(formData.email);
        console.log("resend resp", resp);
        if (resp == true) {
          openModal();
        } else {
          alert("Something went wrong... Please try again later");
        }
      } else if (error.message == "Incorrect username or password.") {
        alert(error.message);
      } else if (error.message == "User does not exist.") {
        alert(error.message);
      } else if (error.message == "Password reset required for the user") {
        Auth.forgotPassword(formData.email)
          .then((data) => {
            console.log(data);
            openModalReset();
          })
          .catch((err) => console.log(err));
      } else {
        alert("Something went wrong... Please try again");
      }
    }
  }
  function handleClickToSignUp() {
    console.log("handle clicked");
    browserHistory.push("/register");
  }
  function redirect() {
    console.log("redirect called");
    browserHistory.push("/app");
  }
  const goHome = () => {
    window.location.href = "/";
  };
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://spontasy.com/app/signin" />
      </Helmet>
      {showLoader ? (
        <SkeletonLoader />
      ) : loginStatus ? (
        redirect()
      ) : (
        <div className="bg-black signin__main">
          {/* <p>`${isLoggedIn()}`</p> */}
          <div className="card bg-dark col-lg-4 col-md-6 col-sm-12">
            <div className="card-body">
              <div className="text-center">
                <img
                  className="signin__logo"
                  // src="/res/spordia_logo.png"
                  src={SigninBlue}
                  alt="spontasy-logo-blue"
                  onClick={goHome}
                  role="button"
                />
              </div>
              <h2 className="card-title text-center text-white mb-2">
                Sign in to access all the features
              </h2>
              <form action="">
                <div class="form-group">
                  <input
                    class="form-control form-control-lg mb-3 bg-dark text-white"
                    type="email"
                    placeholder="Email"
                    id="email"
                    name="email"
                    onChange={(e) => handleChange(e)}
                    required
                  ></input>
                  <input
                    class="form-control form-control-lg mb-3 bg-dark text-white"
                    type="password"
                    placeholder="Password"
                    id="password"
                    name="password"
                    onChange={(e) => handleChange(e)}
                    required
                  ></input>
                  <button
                    type="submit"
                    class="btn btn-primary btn-lg btn-block"
                    onClick={signUpNormal}
                    role="button"
                  >
                    Sign in
                  </button>
                  {/* <button
                    type="submit"
                    class="btn btn-secondary btn-lg btn-block"
                    onClick={handleGoogleSignIn}
                    role="button"
                  >
                    <span className="align-items-center align-self-center mr-2 mt-0">
                      <Search />
                    </span>{" "}
                    Sign in with Google
                  </button> */}
                  <div className="d-flex justify-content-between">
                    <Link
                      to={"/app/signup"}
                      className="text-white text-center m-2"
                    >
                      Not a member?{" "}
                      <span
                        className="text-primary"
                        style={{ cursor: "pointer" }}
                      // onClick={handleClickToSignUp}
                      >
                        Sign Up
                      </span>
                    </Link>
                    <Link
                      to={"/app/forgotpassword"}
                      className="text-white text-center m-2 text-primary"
                    >
                      Forgot Password?
                    </Link>
                  </div>
                </div>
                <div class="row justify-content-center align-items-center">
                  <div class="col-4">
                    <hr class="border-top border-white" />
                  </div>
                  <div class="col-2 text-center text-white">OR</div>
                  <div class="col-4">
                    <hr class="border-top" />
                  </div>
                </div>
                <div>
                  <button
                    class="btn btn-secondary btn-lg btn-block d-flex align-items-center"
                    onClick={handleGoogleSignIn}
                    role="button"
                  >
                    <img
                      src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                      alt="Google logo"
                      style={{
                        maxHeight: "1.5rem",
                        verticalAlign: "middle",
                        marginRight: "1rem",
                        marginLeft: "0.5rem", // add some margin to the left of the image
                      }}
                    />
                    <span style={{ flex: "1" }}>Continue with Google</span>
                  </button>
                </div>
              </form>

              <p className="text-center text-white">
                <small>© All rights reserved. Spordia {currentYear}</small>
              </p>
            </div>
          </div>
        </div>
      )}
      {/* Confirmation Modal */}
      <Modal
        show={isOpenModal}
        onHide={closeModal}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title className="model-header">
            Verify your account
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">
          <input
            class="form-control form-control-lg mt-3 mb-3 bg-dark text-white"
            type="text"
            placeholder="Verification Code"
            name="authcode"
            onChange={handleChangeAuthCode}
          ></input>
        </Modal.Body>
        <Modal.Footer className="bg-dark">
          <Button
            variant="secondary"
            onClick={handleResendVerificationCode}
            className="btn btn-primary btn-lg"
          >
            Resend Verification Code
          </Button>
          <Button
            variant="secondary"
            onClick={handleSubmitConfirmSignUp}
            className="btn btn-primary btn-lg"
          >
            Verify
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Confirmation Modal End */}

      {/* Reset Modal */}
      <Modal
        show={isOpenModalReset}
        onHide={closeModalReset}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton className="bg-dark text-white">
          <Modal.Title className="model-header">Reset Password</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">
          <h3 className="text-white">
            Spontasy has re-designed itself. We request you to reset your
            password
          </h3>
          <input
            class="form-control form-control-lg mt-3 mb-3 bg-dark text-white"
            type="text"
            placeholder="Verification Code"
            name="authcode"
            onChange={handleChangeAuthCodeReset}
          ></input>
          <input
            class="form-control form-control-lg mt-3 mb-3 bg-dark text-white"
            type="password"
            placeholder="New Password"
            name="authcode"
            onChange={handleChangeNewPasswordReset}
          ></input>
        </Modal.Body>
        <Modal.Footer className="bg-dark">
          <Button
            variant="secondary"
            onClick={handleResendConfirmationCode}
            className="btn btn-primary btn-lg"
          >
            Resend Confirmation Code
          </Button>
          <Button
            variant="secondary"
            onClick={handleResetSubmitConfirmSignUp}
            className="btn btn-primary btn-lg"
          >
            Reset Password
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Reset Modal End */}
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    user_information: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    user_email: (value) => dispatch(setUserEmail(value)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Signin);
